import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export const contractApiKeyStore = {
  createContract: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_CONTRACT`],
    route: `/Contract`,
    action: 'POST',
  }),
  updateContract: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_CONTRACT`],
    route: `/Contract`,
    action: 'PUT',
  }),
  deleteContract: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_CONTRACT`, id],
    route: `/Contract/${id}`,
    action: 'DELETE',
  }),
  getContracts: (): QueryKeyConfig => ({
    queryKey: [`GET_CONTRACTS`],
    route: `/Contract`,
  }),
  getOfficeContracts: (officeID: number): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_CONTRACTS`, officeID],
    route: `/Contract/mappings/${officeID}`,
  }),
};
